import React from "react";
import { BsFacebook, BsWhatsapp,BsTiktok } from "react-icons/bs";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ height: 0 }}
      whileInView={{ height: "auto" }}
      transition={{ duration: 1 }}
      className="bg-Teal p-10"
    >
      <div className="grid md:grid-cols-4 sm:grid-cols-3 xs:grid-cols-2 grid-cols-1 place-items-start gap-8 text-white">
        <div>
          <div className="font-bold mb-6">{t("contact")}</div>
          <div className="mb-4">
            <div className="text-sm mb-1">
            {t("school_address")}          
            </div> 
            <div className="text-sm mb-1">          
            {t("school_address1")}          
            </div>
            <div className="text-sm mb-1">           
            {t("school_address2")}           
            </div>
            <div className="text-sm">01116872731 - 01025857670 - 01092539823</div>
          </div>
        </div>

        <div>
          <div className="font-bold mb-6">{t("follow_us")}</div>
          <div className="text-sm mb-4">alolaschool2022@gmail.com</div>
          <div className="flex gap-4 mt-4">
            <a
              href="https://www.facebook.com/profile.php?id=100083012454935"
              target={"_blank"}
              rel="noreferrer"
              className="hover:scale-110 text-xl"
            >
              <BsFacebook />
            </a>
            <a
              href="https://www.tiktok.com/discover/مدارس-ورياض-العلا-السودانية-مدينه-نصر"
              target={"_blank"}
              rel="noreferrer"
              className="hover:scale-110 text-xl"
            >
              <BsTiktok />
            </a>
            <a
              href="https://wa.me/+201550609477"
              target={"_blank"}
              rel="noreferrer"
              className="hover:scale-110 text-xl"
            >
              <BsWhatsapp />
            </a>
          </div>
        </div>
        <div>
          <div className="font mb-6">
            <a href="http://www.keeti.sd" target={"_blank"} rel="noreferrer">
              {t("powered_by")}
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Footer;
